/* eslint react-hooks/exhaustive-deps: "warn" */

import { CSSProperties } from 'react';

import cn from 'classnames';

import { Icon } from 'ui/atoms/Icon/Icon';

interface SpinnerProps {
  size?: number;
  className?: string;
  style?: CSSProperties;
}

export const Spinner = ({ size = 16, className, style }: SpinnerProps) => (
  <Icon type="spinner" className={cn('spinner', className)} style={{ width: size, height: size, ...style }} />
);
